/**
 * @file ColumnChooser.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * Columns Template Management Service
 * @class
 */
class ColumnChooser extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    this.request = new Request({tag: 'das'})
   //this.request = new Request({environment: 'local', tag: 'das'})
  }
  /**
   * Get the metadata of the expressions
   *
   * @async
   * @function getMetadata
   * @param {string} layerId - Layer Id
   * @param {Number} environment - Environment Id
   * @param {string} classType - Class type (Info = 1, Grid = 7)
   * @return {Promise<json>} The json with the template
   */
  async getMetadata (layerId, environment, classType) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof classType === 'undefined') reject(new Error('Esperado o tipo de classe'))
      const endPoint = `/api/0.1-a/columnchooser/metadata/${layerId}/${environment}/${classType}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get the categories of the expressions
   *
   * @async
   * @function getCategories
   * @param {string} layerId - Layer Id
   * @param {Number} environment - Environment Id
   * @param {string} classType - Class type (Billing = 0, Info = 1, Filter = 2. Thematic = 6)
   * @param {Number} alwaysOnTop - Positioner include (None = 0, True = 1, False = 2)
   * @return {Promise<json>} The json with the template
   */
  async getCategories (layerId, environment, classType, alwaysOnTop = 0) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof classType === 'undefined') reject(new Error('Esperado o tipo de classe'))
      const endPoint = `/api/0.1-a/columnchooser/template/${layerId}/${environment}/${classType}/${alwaysOnTop}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get template
   *
   * @async
   * @function getTemplate
   * @param {string} layerId - Layer Id
   * @param {Number} environment - Environment Id
   * @param {string} classType - Class type (Billing = 0, Info = 1, Filter = 2. Thematic = 6)
   * @param {Number} alwaysOnTop - Positioner include (None = 0, True = 1, False = 2)
   * @return {Promise<json>} The json with the template
   */
  async getTemplate (layerId, environment, classType, alwaysOnTop = 0) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o GUID do layer'))
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof classType === 'undefined') reject(new Error('Esperado o tipo de classe'))
      const endPoint = `/api/0.1-a/columnchooser/${layerId}/${environment}/${classType}/${alwaysOnTop}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get template
   *
   * @async
   * @function getTemplateUpload
   * @param {string} layerId - Layer Id
   * @param {Number} environment - Environment Id
   * @param {string} classType - Class type (Billing = 0, Info = 1, Filter = 2. Thematic = 6)
   * @return {Promise<json>} The json with the template
   */
  async getTemplateUpload (layerId, environment, classType) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o objectid do layer'))
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof classType === 'undefined') reject(new Error('Esperado o tipo de classe'))
      const endPoint = `/api/0.1-a/columnchooser/getuploadcolumns/${layerId}/${environment}/${classType}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }


}

export { ColumnChooser }
